import { render, staticRenderFns } from "./UnitRelated.vue?vue&type=template&id=571fffb4&scoped=true"
import script from "./UnitRelated.vue?vue&type=script&lang=js"
export * from "./UnitRelated.vue?vue&type=script&lang=js"
import style0 from "./UnitRelated.vue?vue&type=style&index=0&id=571fffb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571fffb4",
  null
  
)

export default component.exports